export interface SlotParams {
  AARP_AUTH_REDIRECT: string;
  AARP_ANALYTICS_PAGETYPE: string;
  ADD_GOOGLE_VERIFICATION_TAG: boolean;
  ADD_ANALYTICS: boolean;
  SLOT: "prod" | "stage" | "dev";
}

export const SlotParamsDeclaration: { [key: string]: SlotParams } = {
  prod: {
    AARP_AUTH_REDIRECT: "https://games.aarp.org/oauth2",
    AARP_ANALYTICS_PAGETYPE: "games.aarp.org",
    ADD_GOOGLE_VERIFICATION_TAG: true,
    ADD_ANALYTICS: true,
    SLOT: "prod",
  },
  stage: {
    AARP_AUTH_REDIRECT: "https://arenax-testing-games.aarp.org/oauth2",
    AARP_ANALYTICS_PAGETYPE: "arenax-testing-games.aarp.org",
    ADD_GOOGLE_VERIFICATION_TAG: false,
    ADD_ANALYTICS: false,
    SLOT: "stage",
  },
  dev: {
    AARP_AUTH_REDIRECT: "https://arenax-testing-games.aarp.org/oauth2",
    AARP_ANALYTICS_PAGETYPE: "arenax-testing-games.aarp.org",
    ADD_GOOGLE_VERIFICATION_TAG: false,
    ADD_ANALYTICS: false,
    SLOT: "dev",
  },
};
